import Axios from "axios"
import toastr from "toastr"
import "toastr/build/toastr.min.css"
import QueryString from "query-string"

export const requestUserListByFilters = async ({ payload }) => {
  try {
    const filters = payload
    const offset = payload["currentPage"] ? payload["currentPage"] - 1 : 0
    const limit = payload["pageSize"] || 10
    _.unset(filters, "currentPage")
    let data = await Axios.post(
      `/api/user/getUserByFilters?offset=${offset}&limit=${limit}`,
      { filters: payload }
    )
    return data
  } catch (error) {
    throw error
  }
}
export const requestUpsertAppUser = async payload => {
  const { action } = payload.query
  try {
    if (action === "create") {
      const response = await Axios.post(
        `/api/user/create?${QueryString.stringify(payload.query)}`,
        payload.formData
      )
      const { data= {} } = response;
      if (data && data.code === 400 && data.message === "User already exists") {
        toastr.error("User Already Exists")
        return;
      } else {
        toastr.success("Action successfull!!")
        return data
      }
    } else {
      const data = await Axios.put(
        `/api/user/update?${QueryString.stringify(payload.query)}`,
        payload.formData
      )
      toastr.success("Action successfull!!")
      return data
    }
  } catch (error) {
    toastr.error("Action Failed !!")
    throw error
  }
}
// export const requestUpsertAppUser = async payload => {
//   const { action } = payload.query
//   try {
//     if(action==="create") {
//       const data = await Axios.post(
//         `/api/user/create?${QueryString.stringify(
//           payload.query
//         )}`,
//         payload.formData
//       )
//       toastr.success("Action successfull!!")
//       return data
//     }
//     else {
//       const data = await Axios.put(
//         `/api/user/update?${QueryString.stringify(
//           payload.query
//         )}`,
//         payload.formData
//       )
//       toastr.success("Action successfull!!")
//       return data
//     }

//   } catch (error) {
//     toastr.error("Action Failed !!")
//     throw error
//   }
// }

export const requestAddUser = async payload => {
  const { action } = payload.query
  try {
    if (action === "create") {
      const data = await Axios.post(
        `/api/user/addUser?${QueryString.stringify(payload.query)}`,
        payload.formData
      )
      toastr.success("Action successfull!!")
      return data
    } else {
      const data = await Axios.put(
        `/api/user/update?${QueryString.stringify(payload.query)}`,
        payload.formData
      )
      toastr.success("Action successfull!!")
      return data
    }
  } catch (error) {
    toastr.error("Action Failed !!")
    throw error
  }
}

export const requestEmailsOfUsers = async ({ payload }) => {
  try {
    const data = await Axios.get(
      `/api/user/getEmailsOfAllUsers?appCode=${payload}`
    )
    return data
  } catch (error) {
    throw error
  }
}

export const requestDeleteAppUser = async payload => {
  try {
    const data = await Axios.delete(
      `/api/user/deleteUserByUUID?userId=${payload.id}&appCode=${payload.appCode}`
    )
    return data
  } catch (error) {
    throw error
  }
}
